import http from '../../../service/axios/httpRequest';

const CHUNK_SIZE = 0.9 * 1024 * 1024;

const createUuid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = (Math.random() * 16) | 0;
    const value = character === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
});

export const uploadFileGetUuid = async (file, onProgress) => {
    const uuid = createUuid();
    const originalName = file.name;
    const mimetype = file.type || 'application/octet-stream';
    const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));

    for (let index = 0; index < totalChunks; index += 1) {
        const formData = new FormData();
        formData.append('chunk', file.slice(index * CHUNK_SIZE, (index + 1) * CHUNK_SIZE));
        formData.append('uuid', uuid);
        formData.append('index', String(index));
        formData.append('originalName', originalName);
        formData.append('mimetype', mimetype);
        await http.post('/bff/upload-bff', formData);
        onProgress?.(index + 1, totalChunks);
    }

    await http.post('/bff/upload-bff/complete', { uuid, originalName, mimetype });
    return { uuid, originalName, mimetype };
};
